import React, { useState, useEffect } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Fab } from "@mui/material";

const WhatsAppButton: React.FC = () => {
  const phoneNumber = "56910207411";
  const message = "Hola, necesito más información.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 1000);
    const hideTimer = setTimeout(() => setDismissed(true), 6000);
    return () => { clearTimeout(showTimer); clearTimeout(hideTimer); };
  }, []);

  return (
    <div className="whatsapp_float" style={{ position: "fixed", bottom: 16, right: 26, zIndex: 9999, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
      {/* Speech bubble */}
      {visible && !dismissed && (
        <div
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 14,
            padding: "10px 14px",
            boxShadow: "0 4px 18px rgba(0,0,0,0.13)",
            fontSize: 13,
            fontWeight: 500,
            color: "#1e293b",
            maxWidth: 220,
            lineHeight: 1.4,
            position: "relative",
            animation: "waBubble 0.3s ease",
          }}
        >
          ¡Hola! ¿Necesitas ayuda para encontrar una kinesiólogo?
          <button
            onClick={() => setDismissed(true)}
            style={{
              position: "absolute",
              top: 4,
              right: 6,
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: 14,
              color: "#94a3b8",
              lineHeight: 1,
              padding: 0,
            }}
          >
            ×
          </button>
          {/* Triangle pointing down-right */}
          <div style={{
            position: "absolute",
            bottom: -8,
            right: 20,
            width: 0,
            height: 0,
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderTop: "8px solid #fff",
            filter: "drop-shadow(0 2px 1px rgba(0,0,0,0.08))",
          }} />
        </div>
      )}

      <Fab
        color="success"
        aria-label="whatsapp"
        sx={{
          backgroundColor: "#25D366",
          "&:hover": { backgroundColor: "#128C7E" },
        }}
        onClick={() => window.open(whatsappUrl, "_blank")}
      >
        <WhatsAppIcon />
      </Fab>

      <style>{`
        @keyframes waBubble {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppButton;
